import { ViewTypes } from 'app/app.types';
import { BookingMethods, IBooking, ICustomer, IServiceItem, ITableItem } from 'shared-types/SharedTypes';

/**
 * Purpose of these "Actions" is to mimic a more redux-style of event management, which
 * should make transitioning to redux a little easier when the time comes.
 */

const NS = 'NewBookingActionsService';


export const NEW_BOOKING_CLOSED = 'NEW_BOOKING_CLOSED';
export const NEW_BOOKING_OPENED = 'NEW_BOOKING_OPENED';

export interface INewBookingData {
  bookDate: Date;
  bookTable: ITableItem;
  bookingMethod: BookingMethods;
  bookingDuration?: number;
  bookingToMove: IBooking;
  customer: ICustomer;
  selectedService?: IServiceItem;
}

class NewBookingActionsService {
  private $rootScope: any;
  private readyCB: () => void;

  setup($rootScope: any) {
    this.$rootScope = $rootScope;
    if (this.readyCB) {
      this.readyCB();
    }
  }

  registerForReadyCB(cb: () => void) {
    if (this.$rootScope) {
      cb();
    } else {
      this.readyCB = cb;
    }
  }

  onLegacyNewBooking({bookDate, bookTable, bookingMethod, bookingToMove, customer, bookingDuration, selectedService}: INewBookingData) {
    this.$rootScope.$emit('new-booking', {}, bookDate, bookTable, bookingMethod, bookingToMove, customer, bookingDuration, selectedService);
  }

  onNewBookingOpened(payload: INewBookingData) {
    return this.$rootScope.$broadcast(NEW_BOOKING_OPENED, { payload });
  }

  onNewBookingClosed() {
    return this.$rootScope.$broadcast(NEW_BOOKING_CLOSED);
  }

  handleNewBookingOpened(cb: (payload: INewBookingData) => void) {
    return this.$rootScope.$on(NEW_BOOKING_OPENED, (evt: any, data: { payload: INewBookingData }) =>
      cb(data.payload)
    );
  }

  handleNewBookingClosed(cb: () => void) {
    return this.$rootScope.$on(NEW_BOOKING_CLOSED, () => cb());
  }
}

// singleton
const instance = new NewBookingActionsService();
export default instance;
